import { VideoProject } from "@/services/bedrock";

export type VideoProjectStatusColumnId =
  | "submitted_for_editing"
  | "editing"
  | "submitted_for_testing"
  | "testing"
  | "completed";

export interface VideoProjectStatusColumnDef {
  id: VideoProjectStatusColumnId;
  label: string;
  statuses: VideoProject.Status[];
}

export const VIDEO_PROJECT_STATUS_COLUMNS: VideoProjectStatusColumnDef[] = [
  {
    id: "submitted_for_editing",
    label: "Submitted for Editing",
    statuses: [VideoProject.Status.SUBMITTED_FOR_EDITING],
  },
  {
    id: "editing",
    label: "Editing",
    statuses: [VideoProject.Status.EDITING],
  },
  {
    id: "submitted_for_testing",
    label: "Submitted for Testing",
    statuses: [VideoProject.Status.SUBMITTED_FOR_TESTING],
  },
  {
    id: "testing",
    label: "Testing",
    statuses: [VideoProject.Status.TESTING],
  },
  {
    id: "completed",
    label: "Completed",
    statuses: [
      VideoProject.Status.READY_TO_POST,
      VideoProject.Status.SCHEDULED,
      VideoProject.Status.POSTED,
      VideoProject.Status.POST_FAILED,
    ],
  },
];

const STATUS_TO_COLUMN_ID = new Map<VideoProject.Status, VideoProjectStatusColumnId>(
  VIDEO_PROJECT_STATUS_COLUMNS.flatMap(column => column.statuses.map(status => [status, column.id] as const))
);

export function getStatusColumnId(status: VideoProject.Status): VideoProjectStatusColumnId | undefined {
  return STATUS_TO_COLUMN_ID.get(status);
}

export function getRepresentativeStatusForColumn(columnId: VideoProjectStatusColumnId): VideoProject.Status {
  return VIDEO_PROJECT_STATUS_COLUMNS.find(column => column.id === columnId)!.statuses[0];
}

const INTERNAL_STATUS_COLUMN_IDS = new Set<VideoProjectStatusColumnId>(["editing", "submitted_for_testing", "testing"]);

export function visibleStatusColumns(revealInternalStatuses: boolean): VideoProjectStatusColumnDef[] {
  if (revealInternalStatuses) return VIDEO_PROJECT_STATUS_COLUMNS;
  return VIDEO_PROJECT_STATUS_COLUMNS.filter(column => !INTERNAL_STATUS_COLUMN_IDS.has(column.id));
}
